import MessageBar from './MessageBar.vue';
export default MessageBar;
